"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSignConfidentialityAgreementDto = instanceOfSignConfidentialityAgreementDto;
exports.SignConfidentialityAgreementDtoFromJSON = SignConfidentialityAgreementDtoFromJSON;
exports.SignConfidentialityAgreementDtoFromJSONTyped = SignConfidentialityAgreementDtoFromJSONTyped;
exports.SignConfidentialityAgreementDtoToJSON = SignConfidentialityAgreementDtoToJSON;
exports.SignConfidentialityAgreementDtoToJSONTyped = SignConfidentialityAgreementDtoToJSONTyped;
/**
 * Check if a given object implements the SignConfidentialityAgreementDto interface.
 */
function instanceOfSignConfidentialityAgreementDto(value) {
    if (!('signature' in value) || value['signature'] === undefined)
        return false;
    return true;
}
function SignConfidentialityAgreementDtoFromJSON(json) {
    return SignConfidentialityAgreementDtoFromJSONTyped(json, false);
}
function SignConfidentialityAgreementDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'signature': json['signature'],
    };
}
function SignConfidentialityAgreementDtoToJSON(json) {
    return SignConfidentialityAgreementDtoToJSONTyped(json, false);
}
function SignConfidentialityAgreementDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'signature': value['signature'],
    };
}
//# sourceMappingURL=SignConfidentialityAgreementDto.js.map